// frontend/src/components/blog/reader/BlogPost.js
import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useAuth } from "../../../components/AuthContext";
import axios from "axios";
import CommentSection from "../common/CommentSection";
import "./BlogPost.css";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/blog/posts/${slug}`,
          { headers: token ? { Authorization: `Bearer ${token}` } : {} }
        );
        setPost(response.data);
      } catch (err) {
        setError("Failed to load blog post");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug, token]);

  if (loading) return <div className="blog-loading">Loading post...</div>;
  if (error) return <div className="blog-error">{error}</div>;
  if (!post) return <div className="blog-error">Post not found</div>;

  return (
    <div className="blog-post-container">
      <div className="blog-post-header">
        <Link to="/blog" className="back-link">
          ← Back to Blog
        </Link>
        <h1>{post.title}</h1>
        <div className="post-meta">
          <div className="author-info">
            <img
              src={post.author.profilePicture || "/images/default-avatar.png"}
              alt={`${post.author.firstName} ${post.author.lastName}`}
              className="author-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/default-avatar.png";
              }}
            />
            <div className="author-details">
              <span className="post-author">
                By: {post.author.firstName} {post.author.lastName}
              </span>
              <span className="post-date">
                {new Date(post.createdAt).toLocaleDateString()}
              </span>
            </div>
          </div>
          {post.category && (
            <span className="post-category">{post.category}</span>
          )}
        </div>
      </div>

      {post.featuredImage && (
        <div className="post-featured-image">
          <img
            src={
              post.featuredImage.startsWith("http://") ||
              post.featuredImage.startsWith("https://")
                ? post.featuredImage
                : `${process.env.REACT_APP_SERVER_BASE_URL}${post.featuredImage}`
            }
            alt={post.title}
          />
        </div>
      )}

      <div
        className="post-content"
        dangerouslySetInnerHTML={{ __html: post.content }}
      />

      {post.tags && post.tags.length > 0 && (
        <div className="post-tags">
          {post.tags.map((tag) => (
            <span key={tag} className="tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      <CommentSection postId={post._id} />
    </div>
  );
};

export default BlogPost;
